.breakdownContainer {
  display: flex;
  flex-direction: column;
  background-color: var(--static-background-standard);
  border-radius: 1rem;
  padding: 1.5rem;
  border: 1px solid var(--static-divider-standard);
}
